<template>
    <v-row class="minHeightContent">
        <v-col cols="12" md="9" class="mx-auto minHeightContent">
            <v-card width="100%">
                <v-app-bar flat style="z-index: 10;">
                    <v-toolbar-title class="text-h6 pl-0">
                        <v-list dense id="listCalendar"
                            style="min-width: 350px; position: absolute; margin-top: -32px; z-index: 10;">
                            <v-list-group v-model="isOpen">
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ calendarTitle }}</v-list-item-title>
                                    </v-list-item-content>
                                </template>

                                <v-list-item>
                                    <v-list-item-content style="min-height: 300px;">
                                        <div style="text-align: center;">
                                            <v-btn icon style="max-width: 48px;"
                                                @click="backCalendar"><v-icon>fa-chevron-left</v-icon></v-btn>
                                            <span>{{ calendarTitle }}</span>
                                            <v-btn icon style="max-width: 48px;"
                                                @click="nextCalendar"><v-icon>fa-chevron-right</v-icon></v-btn>
                                        </div>
                                        <v-calendar 
                                            ref="calendar" 
                                            color="primary" 
                                            :events="events" 
                                            :month-format="monthFormat"
                                            :weekday-format="weekdayFormat"
                                            :weekdays="weekday" 
                                            v-model="focus"
                                            :event-color="getEventColor" 
                                            :type="type"
                                            :locale="localeCurrent"
                                            @click:more="viewDay" 
                                            @click:date="viewDay"
                                            @click:event="showEvent"
                                            @change="changeCalendar"
                                        ></v-calendar>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                        </v-list>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn @click="todayCalendar">{{ $t('calendar.today') }}</v-btn>
                </v-app-bar>
            </v-card>

            <v-card width="100%" class="mt-2" id="content-calendar">
                <v-card-text v-if="bandCalendar">
                    <div v-for="(item, year) in filteredCalendar" :key="`year-${year}`">
                        <template v-for="(month, i) in months">
                            <div :key="`month-${i}`" :id="`${month}-${year}`" v-if="item[month].visible">
                                    <v-card>
                                        <v-card-title>{{ typeTitle($options.filters.formatDateForHumans(getDate(i,year),false,false,false,true)) }}</v-card-title>
                                    </v-card>
                                    <div class="font-weight-bold ml-8 my-4" id="calendar">
                                        <v-timeline :dense="windowWidth < 960 ? true : $vuetify.breakpoint.smAndDown"
                                            class="calendar-timeline">
                                            <template v-for="(week, j) in item[month].weeks">
                                                <v-timeline-item small :key="`week-${j}-${i}`" :color="bgColor"
                                                    class="item-week">
                                                    <template slot="opposite" v-if="!week.bandReverse && windowWidth > 959">
                                                        {{ $options.filters.getRangeDate(week.start,week.end) }}
                                                    </template>
                                                    <template v-else>
                                                        <span class="float-md-right">{{ $options.filters.getRangeDate(week.start,week.end) }}</span>
                                                    </template>
                                                </v-timeline-item>
                                                <v-timeline-item 
                                                    v-for="(event, k) in week.events"
                                                    :key="`events-${j}-${i}-${k}`" 
                                                    :color="event.color"
                                                    :class="`no-item-week ${event.bandReverse ? '' : 'my-event'}`"
                                                    fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <span class="white--text eventTitle">
                                                            {{ $options.filters.getDateTitle(event.start) }}
                                                        </span>
                                                    </template>
                                                    <template slot="opposite" v-if="event.bandReverse && windowWidth > 959">
                                                        <v-alert outlined :color="event.color" class="mb-0 eventStyle"
                                                            @click="showEvent({ nativeEvent: $event, event })"
                                                            :id="`d-${event.start}`">
                                                            {{ (event.name || '').toUpperCase() }}
                                                        </v-alert>
                                                    </template>
                                                    <template v-else>
                                                        <v-alert outlined :color="event.color" class="mb-0 eventStyle"
                                                            @click="showEvent({ nativeEvent: $event, event })"
                                                            :id="`d-${event.start}`">
                                                            <span>{{ (event.name || '').toUpperCase() }}</span>
                                                        </v-alert>
                                                    </template>
                                                </v-timeline-item>
                                            </template>
                                        </v-timeline>
                                    </div>
                            </div>
                        </template>
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <h2 class="msg-info">
                        <i class="fas fa-exclamation-triangle"></i>
                        {{ $t("calendar.event-not-available") }}
                    </h2>
                </v-card-text>
            </v-card>

        </v-col>
    </v-row>
</template>

<script>
import moment from 'moment-timezone';
import axios from "axios";
import {
    VRow, VCol, VBtn, VCard, VCardTitle, VCardText, VAppBar, VToolbarTitle, VList, VListGroup, VListItem, VListItemContent, VIcon, VCalendar, VSpacer, VTimeline, VTimelineItem, VAlert, VListItemTitle
} from 'vuetify/lib';

export default {
    components: {
        VRow, VCol, VBtn, VCard, VCardTitle, VCardText, VAppBar, VToolbarTitle, VList, VListGroup, VListItem, VListItemContent, VIcon, VCalendar, VSpacer, VTimeline, VTimelineItem, VAlert, VListItemTitle
    },
    props: {
        eventsCalendar: { type: Array, default: () => [] },
        typeCalendar: { type: String, default: 'store' },
        promoterId: { type: Number, default: 0 },
        registrationObj: Object
    },
    data() {
        return {
            monthFormat: null,
            weekday: [1, 2, 3, 4, 5, 6, 0],
            focus: "",
            events: [],
            type: "month",
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            year: null,
            month: null,
            windowWidth: 0,
            dateFocus: null,
            isOpen: false,
            bandChange: false,
            yearStart: null,
            yearEnd: null,
            filteredCalendar: {},
            eventsArray: [],
            registrationsArray: [],
            defaultEventColor: '#45615F'

        };
    },
    mounted() {
        if(this.promoterId) {
            this.Init(true);
        }
    },
    computed: {
        calendar() {
            return this.$store.getters['GET_CALENDAR'];
        },
        bandRefreshCalendar() {
            return this.$store.getters['GET_REFRESH_CALENDAR'];
        },
        localeCurrent() {
            return this.$i18n.locale;
        },
        monthNow() {
            let date = new Date();
            let month = date.getMonth();
            let year = date.getFullYear();
            if (this.dateFocus) {
                let dateMoment = this.dateFocus;
                month = parseInt(dateMoment.format('MM')) - 1;
                year = dateMoment.format('YYYY');
            }
            return this.typeTitle(this.$options.filters.formatDateForHumans(`${year}-${month}-01`,false,false,false,true));
        },
        navBarColor: function () {
            return this.$store.getters['env/GET_NAVBAR_COLOR'];
        },
        bgColor: function () {
            return this.$store.getters["env/GET_SUBHEADER_COLOR"];
        },
        calendarTitle() {
            if (this.$refs.calendar) {
                return this.typeTitle(this.$refs.calendar.title.toString());
            }
            return this.typeTitle(this.monthNow);
        },
        loadingOldEvents() {
            return this.yearStart ? !this.calendar[this.yearStart] : false;
        },
        loadingNewEvents() {
            return this.yearEnd ? !this.calendar[this.yearEnd] : false;
        },
        yearsCalendar() {
            return Object.keys(this.filteredCalendar);
        },
        bandCalendar() {
            if (Object.keys(this.filteredCalendar).length > 0) {
                return true;
            }
            return false;
        }
    },
    methods: {
        async getEventsArray() {
            if(this.yearStart) {
                let stringDate = `${this.yearStart}-01-01`;
                try {
                    const eventsResponse = await axios.post(
                        `${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/event/getEventsForCalendar?date=${stringDate}&type=event&promoterId=` + this.promoterId
                    );

                    let events = [];
                    const data = eventsResponse.data.message
                    if(Array.isArray(data) && data.length > 0) {
                        data.forEach((event) => {
                            const eventCalendar = this.eventsCalendar.find((e) => e.id === event.id);
                            if(eventCalendar) {
                                event.color = eventCalendar.colorCode ?? this.defaultEventColor;
                                events.push(event);
                            }


                        })
                    }
                    return events;
                } catch {
                    return [];
                }
            }
            return [];
        },
        async getRegistrationsArray() {
            return [];
        },
        async Init(bandReset = false) {
            const ea = await this.getEventsArray();
            const ra = await this.getRegistrationsArray();
            
            this.eventsArray = ea
            this.registrationsArray = ra; 
            let now = new moment();
            this.dateFocus = this.dateFocus ? this.dateFocus : now;
            let yearNow = parseInt(now.format('YYYY'));
            this.year = this.year ? this.year : yearNow;
            let yearNext = yearNow + 1;
            this.month = this.month ? this.month : now.format('MMMM');
            this.yearStart = this.yearStart ? this.yearStart : yearNow;
            this.yearEnd = this.yearEnd ? this.yearEnd : yearNext;
            this.$store.dispatch('GET_CALENDAR_STRUCTURE', yearNow - 1);
            this.$store.dispatch('GET_CALENDAR_STRUCTURE', yearNow);
            this.$store.dispatch('GET_CALENDAR_STRUCTURE', yearNext);
            this.updateRange();
            this.refreshWidth();
            const parent = this;
            window.addEventListener('resize', () => {
                this.refreshWidth();
            });
            setTimeout(() => {
                if(bandReset) {
                    parent.focusDateInitial();
                }
                setTimeout(() => {
                    parent.addEventScroll();
                }, 2000);

            }, 500);
            document.addEventListener('click', function (event) {
                var listGroup = document.getElementById('listCalendar');

                if (listGroup && !listGroup.contains(event.target)) {
                    if (parent.isOpen) {
                        parent.isOpen = false;
                    }
                }
            });
        },
        weekdayFormat(day) {
            let _day = '';
            switch (day.weekday) {
                case 0:
                    _day = this.$t("calendar.weekdays.sun");
                    break;
                case 1:
                    _day = this.$t("calendar.weekdays.mon");
                    break;
                case 2:
                    _day = this.$t("calendar.weekdays.tue");
                    break;
                case 3:
                    _day = this.$t("calendar.weekdays.wed");
                    break;
                case 4:
                    _day = this.$t("calendar.weekdays.thu");
                    break;
                case 5:
                    _day = this.$t("calendar.weekdays.fri");
                    break;
                case 6:
                    _day = this.$t("calendar.weekdays.sat");
                    break;
            }
            return _day;
        },
        getEventColor(event) {
            return event.color;
        },
        showEvent({ event }) {
            this.$emit('handleEventClick', { event: this.eventsCalendar.find((e) => e.id === event.id) });
        },
        viewDay({ date }) {
            const container = document.getElementById('content-calendar')
            const element = document.getElementById(`d-${date}`);
            if (container && element) {
                container.scroll({
                    top: element.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
                //element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
            } else {
                let year = moment(date).format('YYYY');
                let yearDate = parseInt(year);
                let month = moment(date).format('MMMM');
                this.year = yearDate;
                this.month = month;
                this.focusCalendar();
            }
            this.isOpen = false;
        },
        typeTitle(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        },
        async getWeekDates(year) {
            const startDate = moment(year, 'YYYY').startOf('year');
            const endDate = moment(year, 'YYYY').endOf('year');
            let firstSunday = startDate.clone().endOf('isoWeek');
            let structureYear = {};
            let aux = firstSunday.clone().add(6, 'days');
            let month = startDate.format('MMMM');
            let monthAb = startDate.format('MMM');
            let monthNumber = startDate.format('MM');
            let day = startDate.format('D');
            structureYear[month] = {
                weeks: [],
                title: `${month} ${year}`
            };
            let monthEnd = aux.format('MM');
            let monthEndTextAb = aux.format('MMM');
            let dayEnd = aux.format('D');
            let range = '';
            if (monthNumber == monthEnd) {
                range = `${monthAb} ${day} - ${dayEnd}`;
            } else {
                range = `${monthAb} ${day} - ${monthEndTextAb} ${dayEnd}`;
            }
            structureYear[month].weeks.push({
                start: firstSunday.format('YYYY-MM-DD'),
                startObject: firstSunday,
                end: aux.format('YYYY-MM-DD'),
                endObject: aux,
                rangeText: range,
                bandReverse: false,
                cont: null,
                events: []
            });
            firstSunday = aux;

            let currentDate = firstSunday.clone().add(1, 'days');

            while (currentDate.isSameOrBefore(endDate)) {
                let endWeek = currentDate.clone().add(6, 'days');
                month = currentDate.format('MMMM');
                monthAb = currentDate.format('MMM');
                monthNumber = currentDate.format('MM');
                day = currentDate.format('D');
                if (!(month in structureYear)) {
                    structureYear[month] = {
                        weeks: [],
                        title: `${month} ${year}`
                    };
                }
                monthEnd = endWeek.format('MM');
                monthEndTextAb = aux.format('MMM');
                dayEnd = endWeek.format('D');
                if (monthNumber == monthEnd) {
                    range = `${monthAb} ${day} - ${dayEnd}`;
                } else {
                    range = `${monthAb} ${day} - ${monthEndTextAb} ${dayEnd}`;
                }
                structureYear[month].weeks.push({
                    start: currentDate.format('YYYY-MM-DD'),
                    startObject: currentDate,
                    end: endWeek.format('YYYY-MM-DD'),
                    endObject: endWeek,
                    rangeText: range,
                    bandReverse: false,
                    cont: null,
                    events: []
                });
                currentDate = endWeek.clone().add(1, 'days');
            }

            return structureYear;
        },
        async updateRange() {
            let events = [];
            
            if (this.typeCalendar == 'store') {
                try {
                    const eventsArray = await this.eventsArray;
                    if(eventsArray && eventsArray.length > 0) {
                        eventsArray.forEach((event) => {
                            events.push({
                                id: event.id,
                                name: event.eventName,
                                start: event.eventDate,
                                end: event.eventDate,
                                color: event.color,
                            });
                        });
                    }
                    this.events = events;
                } catch {
                    this.events = [];
                }
            } else {
                this.events = this.eventsCalendar;
            }
        },
        isPar(number) {
            if (number % 2 === 0) {
                return true;
            } else {
                return false;
            }
        },
        refreshWidth() {
            this.windowWidth = window.innerWidth;
        },
        backCalendar() {
            this.bandChange = true;
            this.removeEventScroll();
            this.dateFocus = this.dateFocus.subtract(1, 'month');
            this.year = parseInt(this.dateFocus.format('YYYY'));
            this.month = this.dateFocus.format('MMMM');
            this.focus = this.dateFocus.toDate();
            this.focusCalendar();
            setTimeout(() => {
                this.addEventScroll();
            }, 2000);
        },
        nextCalendar() {
            this.bandChange = true;
            this.removeEventScroll();
            this.dateFocus = this.dateFocus.add(1, 'month');
            this.year = parseInt(this.dateFocus.format('YYYY'));
            this.month = this.dateFocus.format('MMMM');
            this.focus = this.dateFocus.toDate();
            this.focusCalendar();
            setTimeout(() => {
                this.addEventScroll();
            }, 2000);
        },
        todayCalendar() {
            this.bandChange = true;
            this.removeEventScroll();
            this.dateFocus = new moment();
            this.year = parseInt(this.dateFocus.format('YYYY'));
            this.month = this.dateFocus.format('MMMM');
            this.focus = this.dateFocus.toDate();
            this.focusCalendar();
            setTimeout(() => {
                this.addEventScroll();
            }, 2000);
        },
        loadOldEvents(bandScroll = false) {
            if (this.yearStart) {
                this.yearStart--;
                this.$store.dispatch('GET_CALENDAR_STRUCTURE', this.yearStart);
                this.$store.dispatch('GET_CALENDAR_STRUCTURE', this.yearNow - 1);
                let time = bandScroll ? 1000 : 500;
                setTimeout(() => {
                    this.focusCalendar();
                }, time);
            }
        },
        loadNewEvents(bandScroll = false) {
            if (this.yearEnd) {
                this.yearEnd++;
                this.$store.dispatch('GET_CALENDAR_STRUCTURE', this.yearEnd);
                let time = bandScroll ? 1000 : 500;
                setTimeout(() => {
                    this.focusCalendar();
                }, time);
            }
        },
        changeCalendar(newDate) {
            if (!this.bandChange) {
                let startDate = new moment(newDate.start.date);
                this.dateFocus = startDate;
                this.focus = startDate.toDate();
            } else {
                this.bandChange = false;
            }
        },
        focusCalendar() {
            const container = document.getElementById('content-calendar')
            const element = document.getElementById(`${this.month}-${this.year}`);
            if (container && element) {
                container.scroll({
                    top: element.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
            } else if (this.typeCalendar == 'store') {
                if (this.year < this.yearStart) {
                    this.loadOldEvents(true);
                } else if (this.year > this.yearEnd) {
                    this.loadNewEvents(true);
                } else {
                    //console.table(this.calendar);
                }
            }
        },
        scrollFunction() {
            const element = document.getElementById('content-calendar');
            if (element) {
                const monthElements = element.querySelectorAll('.v-card__text > div:not(.row) > div');
                let monthScroll = undefined;
                if (monthElements.length > 0) {
                    let band = true;
                    let i = 0;
                    do {
                        if (monthElements[i]) {
                            let elementRect = monthElements[i].getBoundingClientRect();
                            let containerRect = element.getBoundingClientRect();
                            if (elementRect.bottom > containerRect.top && elementRect.bottom < containerRect.bottom) {
                                monthScroll = monthElements[i];
                                band = false;
                            }
                            i++;
                        } else {
                            band = false;
                        }
                    } while (band);
                }
                if (monthScroll) {
                    let id = monthScroll.id;
                    let arrayId = id.split('-');
                    let month = arrayId[0];
                    let year = parseInt(arrayId[1]);
                    if (this.year != year || this.month != month) {
                        this.year = year;
                        this.month = month;
                        const _date = moment(`${month} ${year}`, 'MMMM YYYY');
                        this.bandChange = true;
                        this.dateFocus = _date;
                        this.focus = this.dateFocus.toDate();
                    }
                }
            }
        },
        addEventScroll() {
            const elementCalendar = document.getElementById('content-calendar');
            if (elementCalendar) {
                elementCalendar.addEventListener('scroll', this.scrollFunction);
            }
        },
        removeEventScroll() {
            const elementCalendar = document.getElementById('content-calendar');
            if (elementCalendar) {
                elementCalendar.removeEventListener('scroll', this.scrollFunction);
            }
        },
        getSettingCalendar() {
            this.events.forEach((event) => {
                let dateStart = moment(event.start);
                let year = dateStart.format('YYYY');
                let month = dateStart.format('MMMM');

                if (this.calendar[year] && this.calendar[year][month]) {
                    this.calendar[year][month].weeks.forEach((week, i) => {
                        if (dateStart.isSameOrAfter(week.startObject) && dateStart.isSameOrBefore(week.endObject)) {
                            let bandIndex = false;
                            let index = -1;
                            week.events.forEach((_event, k) => {
                                let reviewEvent = moment(_event.start);
                                if (reviewEvent.isAfter(dateStart)) {
                                    index = k;
                                    bandIndex = true;
                                }
                            });
                            if (bandIndex) {
                                this.calendar[year][month].weeks[i].events.splice(index, 0, {
                                    ...event,
                                    title: `${dateStart.format('ddd')} ${dateStart.format('D')}`,
                                    subtitle: '',
                                    bandReverse: false,
                                    cont: 0
                                });
                            } else {
                                this.calendar[year][month].weeks[i].events.push({
                                    ...event,
                                    title: `${dateStart.format('ddd')} ${dateStart.format('D')}`,
                                    subtitle: '',
                                    bandReverse: false,
                                    cont: 0
                                });
                            }
                        }
                    });
                }
            });

            for (let year in this.calendar) {
                for (let month in this.calendar[year]) {
                    let cont = 1;
                    this.calendar[year][month].weeks.forEach((week, i) => {
                        this.calendar[year][month].weeks[i].cont = cont;
                        this.calendar[year][month].weeks[i].bandReverse = this.isPar(cont);
                        cont++;
                        week.events.forEach((event, j) => {
                            this.calendar[year][month].weeks[i].events[j].cont = cont;
                            this.calendar[year][month].weeks[i].events[j].bandReverse = this.isPar(cont);
                            cont++;
                        });
                    });
                }
            }
        },
        getFilteredCalendar() {
                let calendar = Object.fromEntries(
                    Object.entries(this.calendar).filter(([,value]) => {
                        let yearStructObj = Object.fromEntries(
                            Object.entries(value).filter(([,value1]) => {
                                let band = false;
                                for (let i = 0; i < value1.weeks.length; i++) {
                                    if (value1.weeks[i].events.length > 0) {
                                        band = true;
                                        break;
                                    }
                                }
                                return band;
                            })
                        );
                        return Object.keys(yearStructObj).length > 0;
                    })
                );
                for (let year in calendar) {
                    for (let month in calendar[year]) {
                        let band = false;
                        for (let i = 0; i < calendar[year][month].weeks.length; i++) {
                            if (calendar[year][month].weeks[i].events.length > 0) {
                                band = true;
                                break;
                            }
                        }
                        calendar[year][month].visible = band;
                    }
                }
                this.filteredCalendar = calendar;
        },
        findEventsForMonth(year,bandNext = false) {
            let _month = '';
            let index = '';
            if(bandNext) {
                index = this.months.indexOf(this.month);                                                                                                                                                      
            }
            for(let month in year) {
                let band = false;
                let indexN = this.months.indexOf(month);
                year[month].weeks.forEach((week) => {
                    if(indexN >= index && week.events.length > 0) {
                        band = true;
                    }
                });
                if(band) {
                    _month = month;
                    break;
                }
            }
            return _month;
        },
        findReverseEventsForMonth(year,bandNext = false) {
            let _month = '';
            let index = 11;
            if(bandNext) {
                index = this.months.indexOf(this.month);                                                                                                                                                     
            }
            for(let i = 0; i >= 0; i--) {
                let month = this.months[i];
                let indexN = this.months.indexOf(month);
                let band = false;
                year[month].weeks.forEach((week) => {
                    if(indexN >= index && week.events.length > 0) {
                        band = true;
                    }
                });
                if(band) {
                    _month = month;
                    break;
                }
            }
            return _month;
        },
        refreshDateFocus(month,year) {
            this.dateFocus = moment(`${year}-${month}-01`);
            this.focus = this.dateFocus.toDate();
        },
        focusDateInitial() {
            let now = new moment();
            let yearNow = this.year;
            let yearPrevius = yearNow - 1;
            let limit = this.calendar[yearPrevius].December.weeks.length - 1;
            let startDateYear = moment(this.calendar[yearNow].January.startDate);
            let startDateRealYear = moment(`${yearNow}-01-01`);
            if(startDateYear.isSameOrAfter(startDateRealYear)) {
                this.month = this.findEventsForMonth(this.calendar[yearNow],true);
                this.year = yearNow;
                if(this.month == '') {
                    this.month = this.findEventsForMonth(this.calendar[yearNow + 1],true);
                    this.year = yearNow + 1;
                    if(this.month == '') {
                        this.month = this.findReverseEventsForMonth(this.calendar[yearNow],true);
                        this.year = yearNow;
                        if(this.month == '') {
                            this.month = now.format('MMMM');
                            yearNow = parseInt(now.format('YYYY'));
                            this.year = yearNow;
                        } else {
                            this.refreshDateFocus(this.month,this.year);
                        }
                    } else {
                        this.refreshDateFocus(this.month,this.year);
                    }
                } else {
                    this.refreshDateFocus(this.month,this.year);
                }
            } else if(this.calendar[yearPrevius].December.weeks[limit].events.length > 0) {
                this.month = 'December';
                this.year = yearNow - 1;
            } else {
                this.month = now.format('MMMM');
                yearNow = parseInt(now.format('YYYY'));
                this.year = yearNow;
            }
            setTimeout(() => {
                this.focusCalendar(true);
            },200);
        },
        getDate(month,year) {
            let _month = month >= 9 ? (month + 1) : '0'+(month + 1);
            return `${year}-${_month}-01`;
        }
    },
    
    watch: {
        events(val) {
            this.$store.dispatch('GET_SETTING_CALENDAR', val);
        },
        bandRefreshCalendar() {
            if (this.bandRefreshCalendar) {
                this.updateRange();
                this.$store.dispatch('SET_REFRESH_CALENDAR', false);
                setTimeout(() => {
                    this.getFilteredCalendar();
                }, 500);

            }
        },
        eventsArray() {
            this.updateRange();
        },
        registrationsArray() {
            this.updateRange();
        }
    }
};
</script>

<style>
@media only screen and (min-width: 600px) {
    .my-event div.v-timeline-item__body {
        margin: auto 0 !important;
    }

    .item-week,
    .no-item-week {
        max-width: 300px;
    }

    .calendar-time-line::before {
        left: calc(150px - 1px) !important;
    }
}

#content-calendar {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
}

.minHeightContent {
    min-height: calc(100vh - 360px);
}

.eventStyle {
    padding: 6px;
    font-size: small;
    cursor: pointer;
    min-width: 400px;
}

@media only screen and (max-width: 599px) {
    .eventStyle {
        min-width: auto;
    }
}

.eventStyle:hover {
    border-width: 2px !important;
    opacity: 0.8;
}

.eventTitle {
    font-size: x-small;
    text-align: center;
    line-height: normal;
}
</style>

<style scoped>
@media only screen and (min-width: 600px) {
    .v-application--is-ltr .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)::before {
        left: calc(150px - 1px);
        right: initial;
    }
}
</style>